// -------------------------------------------------------------------------------------------------
// Import
// -------------------------------------------------------------------------------------------------

import $ from 'jquery';
import runOnVisible from '../runner-visible';

// -------------------------------------------------------------------------------------------------
// Variables
// -------------------------------------------------------------------------------------------------

const baseClass = 'blog__categories';
let catalogs = [];

// -------------------------------------------------------------------------------------------------
// Classes
// -------------------------------------------------------------------------------------------------

export class Blog {
  constructor(el) {
    this.el = el;
    // this.$sectorBtns = $(el).find(`.btn`);
    // this.$sectorReset = $(el).find(`.${baseClass}-reset`);
    // this.$items = $(`.blog__cards-item`);
    this.$title = $(el).find(`.${baseClass}-title`);

    runOnVisible(this.el, async () => {
      await this.start();
    });
  }

  async start() {
    // this.$sectorBtns.on('click', (e) => {
    //   const btnEl = e.currentTarget;
    //   if (btnEl.classList.contains(`${baseClass}-reset`)) {
    //     return;
    //   }
    //
    //   if (btnEl.classList.contains('btn-primary')) {
    //     this.clearFilters();
    //     return;
    //   }
    //
    //   for (let item of document.querySelectorAll(`.${baseClass} .btn`)) {
    //     item.classList.remove('btn-primary');
    //   }
    //
    //   btnEl.classList.add('btn-primary');
    //
    //   document.querySelector(`.${baseClass} [data-cat="${btnEl.getAttribute('data-cat')}"]`).classList.add('btn-primary');
    //
    //   this.updateItems(btnEl.getAttribute('data-cat'));
    // }).prop('disabled', false);
    //
    // this.$sectorReset.on('click', () => {
    //   this.clearFilters();
    // });

    this.$title.on('click', (e) => {
      let txt = e.target.querySelector('span').innerText;
      e.target.querySelector('span').innerText = txt == '-' ? '+' : '-';
      document.querySelector(`.${baseClass}`).classList.toggle('is-active');
    });
  }

  // updateItems(val) {
  //   this.$items.closest('.blog__cards').addClass('blog__cards-fade-out');
  //
  //   document.querySelector('.blog__cards').addEventListener("transitionend", () => {
  //     for (let item of this.$items) {
  //       if (val != null) {
  //         item.classList.add('d-none');
  //
  //         if (item.getAttribute('data-cat') === val) {
  //           item.classList.remove('d-none');
  //           item.querySelector(`.${baseClass} .btn`).classList.add('btn-primary');
  //         }
  //       } else {
  //         item.classList.remove('d-none');
  //         item.querySelector(`.${baseClass} .btn`).classList.remove('btn-primary');
  //
  //       }
  //     }
  //
  //     this.$items.closest('.blog__cards').removeClass('blog__cards-fade-out');
  //   });
  // }
  //
  // clearFilters() {
  //   for (let item of this.$sectorBtns) {
  //     item.classList.remove('btn-primary');
  //   }
  //
  //   this.$sectorReset.addClass('btn-primary');
  //
  //   this.updateItems();
  // }
}

// -------------------------------------------------------------------------------------------------
// Methods
// -------------------------------------------------------------------------------------------------

export function init() {
  $(`.${baseClass}`).each((i, el) => {
    registerCatalog(new Blog(el));
  });
}

export function registerCatalog(catalog) {
  catalogs.push(catalog);
}

// -------------------------------------------------------------------------------------------------
// Export
// -------------------------------------------------------------------------------------------------

export default {
  init,
};
